<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
       <div slot="queryParams" class="form">
         <div class="queryContainer">
           <div class="queryItem" v-if="this.$store.state.user.roleType !== 2" >
             <label >门店名称:</label>
             <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
           </div>
           <div class="queryItem">
             <label >商品:</label>
             <lk-input class="item" placeholder='请输入商品编码/通用名' clearable v-model.trim="query.nameMix"></lk-input>
           </div>
           <div class="queryItem">
             <label >审批状态:</label>
             <lk-select placeholder='请选择' class="item" v-model.trim='query.auditStatus'>
               <lk-option v-for="item in checkStatusList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
             </lk-select>
           </div>
           <div class="queryItem">
             <label >是否过期:</label>
             <lk-select placeholder='请选择' class="item" v-model.trim='query.expire'>
               <lk-option v-for="item in outOfDateList" :key="item.id" :value='item.id'>{{item.name}}</lk-option>
             </lk-select>
           </div>
           <div class="queryItem">
             <label >申请时间:</label>
             <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.applyTime"></timeStampDatePicker>
           </div>
           <div class="queryItem">
             <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
             <lk-button @click="clear">重置</lk-button>
           </div>
         </div>
       </div>
       <div slot="table">
         <div class="btns">
           <lk-button class="mr8" type='primary' v-if="handlePermission('receiveableLimitAdd')" @click="toAddApplication">新建申请</lk-button>
           <DownloadButton  @on-click="download" v-if="handlePermission('receiveableLimitDownload')"></DownloadButton>
         </div>
         <lk-table border :columns='columns' :data='tableData'/>
       </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import utils from '../../libs/utils';
import sale from '../../services/sale';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'receiveableLimitApply',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
  },
  data() {
    return {
      count: null,
      page: 1,
      query: {
        storeIdList: [],
        nameMix: '',
        auditStatus: null,
        expire: null,
        applyTime: [],
      },
      checkStatusList: [
        {
          id: 1,
          name: '审批通过',
        },
        {
          id: 2,
          name: '审批驳回',
        },
        {
          id: 3,
          name: '审批中',
        },
      ],
      outOfDateList: [
        {
          id: 1,
          name: '未过期',
        },
        {
          id: 2,
          name: '已过期',
        },
      ],
      columns: [
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '申请单号', key: 'code', minWidth: 116 },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedDrugNames', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 116 },
        { title: '审批状态', key: 'auditStatusName', minWidth: 116 },
        { title: '是否过期', key: 'expireName', minWidth: 116 },
        { title: '申请时间', key: 'createTime', minWidth: 116 },
        { title: '审批时间', key: 'approvalTime', minWidth: 116 },
        { title: '生效月份', key: 'takeMonth', minWidth: 116 },
        { title: '申请数量', key: 'approvalAmount', minWidth: 116 },
        { title: '已使用数量', key: 'usedAmount', minWidth: 116 },
        { title: '已过期数量', key: 'expireAmount', minWidth: 116 },
        { 
          title: '操作',
          minWidth: 116,
          fixed: 'right',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'receiveableLimitCheck', params: {id: params.row.id }})
                }
              }
            }, '查看')
          ])
        },
      ],
      tableData: [],
    }
  },
  methods: {
    toAddApplication() {
      this.$router.push({ name: 'receiveableLimitAdd' });
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      if (params.applyTime && params.applyTime.length) {
        params.approvalStartTime = params.applyTime[0];
        params.approvalEndTime = params.applyTime[1];
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      sale.toDownLoadReceiveLimitDoc(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        storeIdList: [],
        nameMix: '',
        auditStatus: null,
        expire: null,
        applyTime: [],
      }
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.applyTime && this.params.applyTime.length) {
        this.params.approvalStartTime = this.params.applyTime[0];
        this.params.approvalEndTime = this.params.applyTime[1];
      }
      sale.getReceivableList(this.params).then(res => {
        if (res.data.status === 200) {
          if (res.data.data.list && res.data.data.list.length) {
            res.data.data.list.forEach(item => {
              item.auditStatusName = this.checkStatusList[item.auditStatus-1].name;
              item.expireName = this.outOfDateList[item.expire-1].name;
              item.createTime = utils.formatDateToSecond(item.createTime);
              item.approvalTime = item.approvalTime ? utils.formatDateToSecond(item.approvalTime) : '';
              item.takeMonth = utils.formatDateToMonth(item.takeMonth);
            })
          }
          this.tableData = res.data.data.list;
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch(err => {
        utils.handleError(err);
      })
    }
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>

<style lang="less" scoped>
  .btns {
    margin-bottom: 12px;
  }
</style>
